<template>
  <div class="box">
    <div class="addEducation">
    <van-form @submit="onSubmit">
        <van-cell-group>
          <!-- <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.empno" placeholder="请输入工号" label="工号"/> -->
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" type="date" v-model="baseinfo.begindate" label="开始时间"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" type="date" v-model="baseinfo.enddate" label="结束时间"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.school" placeholder="请输入学校" label="学校"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.major" placeholder="请输入专业" label="专业"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.studytype" placeholder="请输入学习形式" label="学习形式"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.degree" placeholder="请输入学位" label="学位"/>
        </van-cell-group>
        <van-cell-group>
          <!-- <van-field input-align="right" label-width="140" name="uploader" label="学历证书附件(图片)">
            <template #input>
              <van-uploader v-model="baseinfo.eduattech" />
            </template>
          </van-field> -->
           <van-field input-align="right" label-width="140" v-model="baseinfo.eduattech" placeholder="请输入学位证书附件" label="学历证书附件(图片)"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" label-width="140" v-model="baseinfo.degatteach" placeholder="请输入学位证书附件" label="学位证书附件(图片)"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.remark" placeholder="请输入备注" label="备注"/>
        </van-cell-group>
        <div class="btnBox">
            <van-button round block type="info" native-type="submit" class="btn">确认</van-button>
        </div>
    </van-form>
  </div>
  </div>
</template>

<script>
import api from '@/apis'
import moment from 'moment'
export default {
  name: "addEducation",
  data(){
    return {
      baseinfo:{
        empno: "", //员工工号
        begindate: "", //开始时间
        enddate: "", //结束时间
        school: "", //学校
        major: "", //专业
        studytype: "", //学习形式
        degree: "", //学位
        eduattech: [], //学历证书附件（图片）
        degatteach: "", //学位证书附件（图片）
        remark: "", //备注
      }
    }
  },
  methods: {
    // 提交表单
    onSubmit(){
      let obj = {
        ...this.baseinfo,
        begindate:moment(this.baseinfo.begindate).format('YYYY-MM-DD'),
        enddate:moment(this.baseinfo.enddate).format('YYYY-MM-DD'),
        table:'euBgeducationList',
        saveType:'1',
        empid:this.$store.state.userInfo.empID,
        empno:this.$store.state.userInfo.empNo
      }
      api.setSaveEmpInfo(obj).then(()=>{
        this.$toast('添加成功');
        this.$router.push('/mobile/info')
      })
    },
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .addEducation {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .addEducation {
    width: 276px * $zoom;
  }
}
.box{
  display: flex;
  justify-content: center;
}
.addEducation {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.fromBox{
    height: 90vh;
}
.btnBox{
    width: 100%;
    position: absolute;
    bottom: 20px * $zoom;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px * $zoom 20px * $zoom;
}
.btn {
  width: 80%;
  font-size: 16px * $zoom;
  padding: 20px * $zoom 10px * $zoom;
  border: none;
}
</style>
